module.exports = __webpack_public_path__ + "img/1.2cbebd01.jpg";